import React from "react";
import Carousel from "react-bootstrap/Carousel";

function Carousel1() {
  return (
    <div>
      <Carousel fade style={{ zIndex: "-1", marginTop: "-9rem" }}>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="images/first.jpg"
            alt="First slide"
          />
          <Carousel.Caption>
            <h2 style={{ color: "white" }}>CEO with Most Senior Teacher</h2>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="images/second.jpg"
            alt="Second slide"
          />

          <Carousel.Caption>
            <h2 style={{ color: "white" }}>Primary Kids Performing On Stage</h2>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="images/third.jpg"
            alt="Third slide"
          />

          <Carousel.Caption>
            <h2 style={{ color: "white" }}>Prizes of Appreciation</h2>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </div>
  );
}

export default Carousel1;
